<template lang="pug">
  .d-flex.px-3.pb-3
    span.fantasy__block-max_width--7
      v-select(:items="currencyItems" v-model="currency" label="currency" background-color="blue-grey lighten-4" dense solo flat outlined hide-details @input="update")
    BaseFloatField.flex-grow-1(v-model="quantity", :label="labelquantity" min="0" decimals="2" outlined dense solo flat @input="update")
</template>

<script>
  export default {
    name: "BaseCurrencyInputField",
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      value: {
        type: Object,
        default: function(){
          return {
            currency: '',
            quantity: '',
          }
        }
      },
      labelquantity: {
        type: String,
        default: '',
      },
      currencyItems: {
        type: Array,
        default: function(){
          return []
        }
      },
    },
    data:() => ({
      currency: '',
      quantity: '',
    }),
    watch: {
      value: function(val){
        this.currency = val.currency;
        this.quantity = val.quantity;
      }
    },
    created(){
      this.currency = this.value.currency;
      this.quantity = this.value.quantity;
    },
    methods:{
      update(){
        this.$emit('input', { currency: this.currency, quantity: this.quantity});
      },
    },
  }
</script>

<style lang="sass">
</style>